<template>
  <no-ssr>
  <article class="card" :id="`tagId${id}`">
    <page-columns class="card__columns" :column_half="true">
      <template slot="first">
        <div class="card__content">
          <div class="card__meta">
            <span class="event-date">{{dateStr}}</span>
          </div>
          <link-to :to="linkTo" class="no_border" ><h3 v-html="title"></h3></link-to>
          <div class="description font-size-1">
            <span v-html="text"></span>
            <div class="actions">
              <link-to class="text-black solid" :to="linkTo">Читать далее...</link-to>
            </div>
          </div>

        </div>
      </template>
      <template slot="last">
        <link-to class="card__image" :to="linkTo" >
          <div class="cover" ref="cover" :style="{ backgroundImage: 'url(\''+ (this.isImages ?  this.isImages : image) +'\')', }" >
            <div class="mobile-content">
              <div class="bg"></div>
              <h3 v-html="dateStr+' '+title"></h3>
              <div class="description">
                <span v-html="text"></span>
              </div>
            </div>
          </div>
        </link-to>
      </template>
    </page-columns>
  </article>
  </no-ssr>
</template>

<script>
  import NewsItemMixin from '../mixins/NewItemMixin.js'

  export default {
    mixins: [NewsItemMixin],
    data() {
      return {
        sizeImgError: '540x540',
        isImages: false,
      };
    },
    computed: {
      // linkUrl() {
      //   return '/news/' + this.id;
      // },
    },
  }
</script>

<style lang="scss" scoped>

  .card {
    padding: 30px 0px;
    h3 {
      text-transform: none;
    }
    a {
      color:$color-black;
    }
    &__meta {
      padding: 5px 0px;
      text-transform: uppercase;
     // font-weight: bold;
      font-size: 20px;
    }
    .description {
      margin-bottom: 15px;
      height: 320px;
      .actions {
        margin-top: 15px;
      }
    }

    /deep/ .column-last {
      display: flex;display: -ms-flexbox;
      flex-flow: column nowrap;
      .column-inner {
        flex: 1 0 auto;
        display: flex;display: -ms-flexbox;
        flex-flow: column nowrap;
        a {
          flex: 1 0 auto;
          display: flex;display: -ms-flexbox;
          flex-flow: column nowrap;
          @include ease(opacity);
          @media (max-width: 600px) {
            padding-bottom: 15px;
          }
          &:hover {
            opacity: 0.9;
          }
          .cover {
            flex: 1 0 auto;
            min-height: 320px;
            @include background-cover();
          }
        }
      }
    }


    .mobile-content {
      display: none;
    }

    @media (max-width: $media_md) {
      padding: 30px 0px;
      &__content{
        display: none;
      }
      //$font-size-card: 16px;
      a {
        display: block;
        text-decoration: none;
        position: relative;
        color:$color-white;
        .cover {
          display: flex;display: -ms-flexbox;
          align-items: center;
          height: 100%;
          flex: auto;
          position: relative;
          .mobile-content {
            padding: 20px;
            text-align: center;
            display: block;
             width: 100%;
            .bg {
               @include position-full();
               background: rgba($color-blue-2,0.7);
               z-index: 0;
            }
            h3 {
              font-size: 18px;
            }
            .description {
              font-size: 16px;
            }
            h3,.description {
              position: relative;
              z-index: 100;
              padding: 3px;
            }
          }
        }
      }
      .description {
        height: auto;
      }
    }

    @media (max-width: $media_sm) {
      padding: 35px 0px;
      margin: 0 -15px;
      background: $color-blue-6;
      &:first-child {
        padding-top: 70px;
      }
      &:last-child {
        padding-bottom: 70px;
      }
    }
    @media (max-width: $media_xs) {
      padding: 25px 0px;
    }
  }

</style>



// WEBPACK FOOTER //
// components/shared/cards/CardNewsSmall.vue